module.exports = __webpack_public_path__ + "static/media/home_page_capy_background_m@2x.403b33e5.png";